import {
  Directive,
  ElementRef,
  Renderer2,
  inject,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appDisablePointerEvents]',
  standalone: true,
})
export class DisablePointerEventsDirective implements OnInit, OnChanges {
  @Input() appDisablePointerEvents: boolean | string = true;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnInit(): void {
    this.applyStyle();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.applyStyle();
  }

  private applyStyle(): void {
    // Treat bare attribute usage (empty string) and explicit `false` string as true/false correctly
    const shouldDisable =
      this.appDisablePointerEvents !== false && this.appDisablePointerEvents !== 'false';

    if (shouldDisable) {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');
    }
  }
}
